import { render, staticRenderFns } from "./RightContent.vue?vue&type=template&id=74bfd5b2&scoped=true&"
import script from "./RightContent.vue?vue&type=script&lang=js&"
export * from "./RightContent.vue?vue&type=script&lang=js&"
import style0 from "./RightContent.vue?vue&type=style&index=0&id=74bfd5b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bfd5b2",
  null
  
)

export default component.exports